// Retenciones
// Carga excel


import React, { useEffect, useState, useRef } from 'react';
// @mui material components
import Button from '@mui/material/Button';
import Card from "@mui/material/Card";
import CircularProgress from '@mui/material/CircularProgress';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Grid from '@mui/material/Grid';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import TextField from '@mui/material/TextField';
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import { apiRequest } from "utils/api";
import { useAuth } from "context/AuthContext";
import { useUserData } from "context/UserDataContext";
import { useLanguage } from "context/LanguageContext";
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';


// Argon Dashboard 2 MUI components
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";

// Argon Dashboard 2 MUI examples
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import PageBlueHeader from "components/PageBlueHeader";
import { getEmpresaCountry, isUsEmpresa as checkIsUsEmpresa } from "utils/empresaCountry";



const validarCIlocal = (ci) => {
  if (!/^[0-9]{8}$/.test(ci)) return false;
  const coef = [2, 9, 8, 7, 6, 3, 4];
  const suma = coef.reduce((acc, c, i) => acc + c * Number(ci[i]), 0);
  const digito = (10 - (suma % 10)) % 10;
  return digito === Number(ci[7]);
};

const DOCUMENTO_MAX_LENGTH_US = 20;
const CELULAR_MAX_LENGTH_US = 15;

const BANCOS_URUGUAY = [
  { value: "Itau", label: "Itau" },
  { value: "BROU", label: "BROU" },
  { value: "Bandes", label: "Bandes" },
  { value: "BBVA", label: "BBVA" },
  { value: "Scotiabank", label: "Scotiabank" },
  { value: "Santander", label: "Santander" },
  { value: "MIDINERO", label: "Midinero" },
  { value: "OCA Blue", label: "OCA Blue" },
  { value: "PREX", label: "PREX" },
  { value: "N/A", label: "N/A" },
];

const BANCOS_USA = [
  { value: "Bank of America", label: "Bank of America" },
  { value: "Chase", label: "Chase" },
  { value: "Wells Fargo", label: "Wells Fargo" },
  { value: "Citibank", label: "Citibank" },
  { value: "U.S. Bank", label: "U.S. Bank" },
  { value: "PNC Bank", label: "PNC Bank" },
  { value: "Capital One", label: "Capital One" },
  { value: "TD Bank", label: "TD Bank" },
  { value: "Truist", label: "Truist" },
  { value: "N/A", label: "N/A" },
];

// util simple de debounce
const debounce = (fn, delay = 400) => {
  let id;
  return (...args) => {
    clearTimeout(id);
    id = setTimeout(() => fn(...args), delay);
  };
};

const restriccionesPorBanco = (banco) => {
  switch (banco) {
    case "BROU":
      return {
        maxLength: 14,
        minLength: 14,
        pattern: /^[0-9]{14}$/,
        helperText: "Debe tener 14 dígitos. Ej: 00099299700002"
      };
    case "BHU":
      return {
        maxLength: 10,
        minLength: 10,
        pattern: /^[0-9]{10}$/,
        helperText: "Debe tener 10 dígitos. Ej: 0123456789"
      };
    case "Citibank":
      return {
        maxLength: 10,
        minLength: 10,
        pattern: /^[0-9]{10}$/,
        helperText: "Debe tener 10 dígitos, rellenando con ceros a la izquierda. Ej: 0061436006"
      };
    case "Itau":
      return {
        maxLength: 7,
        minLength: 7,
        pattern: /^[0-9]{7}$/,
        helperText: "Debe tener 7 dígitos, rellenando con ceros a la izquierda. Ej: 3190373"
      };
    case "Scotiabank":
      return {
        maxLength: 10,
        minLength: 7,
        pattern: /^[0-9]{7,10}$/,
        helperText: "Puede tener 7 o 10 dígitos, rellenando con ceros a la izquierda."
      };
    case "Santander":
      return {
        maxLength: 16,
        minLength: 12,
        pattern: /^([0-9]{12}|[0-9]{16})$/,
        helperText: "Debe tener 16 dígitos: 4 sucursal + 12 cuenta (ej: 0001000000000001)"
      };
    case "Banco de la Nación Argentina":
      return {
        maxLength: 12,
        minLength: 12,
        pattern: /^[0-9]{12}$/,
        helperText: "Debe tener 12 dígitos, rellenando con ceros a la izquierda."
      };
    case "BBVA":
      return {
        maxLength: 9,
        minLength: 1,
        pattern: /^[0-9]{1,9}$/,
        helperText: "Hasta 9 dígitos, solo números. Ej: 20237345"
      };
    case "HSBC":
      return {
        maxLength: 10,
        minLength: 10,
        pattern: /^[0-9]{10}$/,
        helperText: "Debe tener 10 dígitos, rellenando con ceros a la izquierda."
      };
    case "Heritage":
      return {
        maxLength: 9,
        minLength: 9,
        pattern: /^[0-9]{9}$/,
        helperText: "Debe tener 9 dígitos, rellenando con ceros a la izquierda."
      };
    case "PREX":
      return {
        maxLength: 8,
        minLength: 8,
        pattern: /^[0-9]{8}$/,
        helperText: "Debe tener 8 dígitos, rellenando con ceros a la izquierda."
      };
    case "MIDINERO":
    case "Mi Dinero":
      return {
        maxLength: 7,
        minLength: 7,
        pattern: /^[0-9]{7}$/,
        helperText: "Debe tener 7 dígitos. Ej: 3259658"
      };
    case "OCA Blue":
      return {
        maxLength: 7,
        minLength: 7,
        pattern: /^[0-9]{7}$/,
        helperText: "Debe tener 7 dígitos, rellenando con ceros a la izquierda."
      };
    case "BAPRO":
      return {
        maxLength: 7,
        minLength: 7,
        pattern: /^[0-9]{7}$/,
        helperText: "Debe tener 7 dígitos. Ej: 5674536"
      };
    default:
      return {
        maxLength: 20,
        minLength: 1,
        pattern: /^[0-9]+$/,
        helperText: "Ingrese el número de cuenta"
      };
  }
};

const restriccionesPorBancoUs = (banco) => {
  if (!banco || banco === "N/A") {
    return {
      maxLength: 17,
      minLength: 0,
      pattern: null,
      helperText: " ",
    };
  }

  return {
    maxLength: 17,
    minLength: 4,
    pattern: /^[0-9]{4,17}$/,
    helperText: "Enter 4 to 17 digits for the account number.",
  };
};


const bankNameToCode = {
  "Itau": "113",
  "BROU": "001",
  "Bandes": "110",
  "BBVA": "153",
  "Scotiabank": "128",
  "Santander": "137",
  "MIDINERO": "6917",
  "OCA Blue": "815",
  "PREX": "452",
  "BHU": "011",
  "Citibank": "021",
  "HSBC": "029",
  "Heritage": "031",
  "Banco de la Nación Argentina": "011",
};

function AgregarUsuario() {
  const navigate = useNavigate();



  const { user, loading: authLoading } = useAuth();
  const { userData, empresaData } = useUserData();
  const { t } = useLanguage();
  const paisEmpresa = getEmpresaCountry(userData, empresaData);
  const isUsEmpresa = checkIsUsEmpresa(userData, empresaData);
  const bancosDisponibles = isUsEmpresa ? BANCOS_USA : BANCOS_URUGUAY;

  useEffect(() => {
    // Si Firebase está cargando, esperar
    if (authLoading) {
      return;
    }

    // Si no hay usuario autenticado, redirigir al login
    if (!user) {
      navigate("/authentication/sign-in");
      return;
    }

    // Si hay usuario, cargar datos
    obtenerYGuardarUserId();
  }, [navigate, user, authLoading]);


  const [formData, setFormData] = useState({
    nombre: '',
    segundoNombre: '',
    apellido: '',
    segundoApellido: '',
    documento: '',
    banco: '',
    numeroCuenta: '',
    email: '',
    celular: '',
    genero: '',
    retenciones: [],
    sueldoMensual: '',
    deleted: false
  });

  const [cedulaValid, setCedulaValid] = useState(null); // null|true|false
  const [cedulaChecking, setCedulaChecking] = useState(false);
  const [documentoExists, setDocumentoExists] = useState(null); // null|true|false
  const [documentoChecking, setDocumentoChecking] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [loading, setLoading] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [modalMessage, setModalMessage] = useState('');
  const [realTimeValidation, setRealTimeValidation] = useState({});

  const abortCtl = useRef(null);
  const abortCtlDocumento = useRef(null);

  const validarCedulaRemoto = debounce(async (ci) => {
    // cancela request anterior (si hay)
    abortCtl.current?.abort();
    abortCtl.current = new AbortController();
    setCedulaChecking(true);

    try {
      const r = await fetch(`https://ciuy-consumers-api.vercel.app/validate/${ci}`,
        { signal: abortCtl.current.signal, mode: "cors" });
      const res = await r.json();
      setCedulaValid(res.valid);
    } catch (err) {
      // si hay error de red (503), confía en el cálculo local
      setCedulaValid(validarCIlocal(ci));
    } finally {
      setCedulaChecking(false);
    }
  }, 450);

  // Función para verificar si el documento ya existe en el sistema
  const verificarDocumentoExistente = debounce(async (documento, usMode = false) => {
    if (!documento || !documento.trim()) {
      setDocumentoExists(null);
      return;
    }

    const minLength = usMode ? 1 : 8;
    if (documento.length < minLength) {
      setDocumentoExists(null);
      return;
    }

    // cancela request anterior (si hay)
    abortCtlDocumento.current?.abort();
    abortCtlDocumento.current = new AbortController();
    setDocumentoChecking(true);

    try {
      const response = await apiRequest(`/verificar-documento/${documento}`, {
        method: 'GET',
        signal: abortCtlDocumento.current.signal
      });

      if (response.ok) {
        const data = await response.json();
        setDocumentoExists(data.exists);
      } else {
        // Si hay error en la API, asumimos que no existe para no bloquear al usuario
        setDocumentoExists(false);
      }
    } catch (err) {
      if (err.name !== 'AbortError') {
        console.error('Error al verificar documento:', err);
        // En caso de error, asumimos que no existe para no bloquear al usuario
        setDocumentoExists(false);
      }
    } finally {
      setDocumentoChecking(false);
    }
  }, 500);

  useEffect(() => {
    const { documento } = formData;

    if (isUsEmpresa) {
      setCedulaValid(null);
      setDocumentoExists(null);
      abortCtl.current?.abort();
      abortCtlDocumento.current?.abort();
      return;
    }

    if (documento.length === 8) {
      // primer filtro local; evita llegar a la API si ya está mal
      if (!validarCIlocal(documento)) {
        setCedulaValid(false);
        setDocumentoExists(null);
        abortCtl.current?.abort();
        abortCtlDocumento.current?.abort();
        return;
      }
      validarCedulaRemoto(documento);
      verificarDocumentoExistente(documento, false);
    } else {
      setCedulaValid(null);
      setDocumentoExists(null);
      abortCtl.current?.abort();
      abortCtlDocumento.current?.abort();
    }
  }, [formData.documento, isUsEmpresa]);

  // Función para validación en tiempo real
  const validateField = (name, value) => {
    const errors = {};

    switch (name) {
      case 'nombre':
        if (!value.trim()) {
          errors.nombre = 'El nombre es obligatorio';
        } else if (value.trim().length < 2) {
          errors.nombre = 'El nombre debe tener al menos 2 caracteres';
        }
        break;
      case 'apellido':
        if (!value.trim()) {
          errors.apellido = 'El apellido es obligatorio';
        } else if (value.trim().length < 2) {
          errors.apellido = 'El apellido debe tener al menos 2 caracteres';
        }
        break;
      case 'email':
        if (!value.trim()) {
          errors.email = 'El email es obligatorio';
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
          errors.email = 'El email no tiene un formato válido (ejemplo: usuario@dominio.com)';
        }
        break;
      case 'celular':
        if (!value.trim()) {
          if (!isUsEmpresa) {
            errors.celular = 'El celular es obligatorio';
          }
        } else if (isUsEmpresa) {
          if (value.length > CELULAR_MAX_LENGTH_US) {
            errors.celular = `El número de celular no puede superar ${CELULAR_MAX_LENGTH_US} dígitos`;
          }
        } else if (value.length !== 9) {
          errors.celular = 'El celular debe tener exactamente 9 dígitos';
        } else if (!/^09/.test(value)) {
          errors.celular = 'El celular debe comenzar con 09';
        }
        break;
      case 'sueldoMensual':
        // El sueldo es opcional, solo validar si se proporciona
        if (value && value.trim() !== '') {
          const sueldo = parseInt(value) || 0;
          if (sueldo <= 0) {
            errors.sueldoMensual = 'El sueldo debe ser mayor a 0';
          } else if (sueldo > 300000) {
            errors.sueldoMensual = 'El sueldo debe ser menor a 300,000. Para sueldos mayores contacte a soporte';
          } else if (!isUsEmpresa && sueldo < 10000) {
            errors.sueldoMensual = 'El sueldo debe ser mayor a 10,000';
          }
        }
        break;
      case 'numeroCuenta':
        // Si se selecciona un banco que no es N/A, el número de cuenta es obligatorio
        if (formData.banco && formData.banco !== "N/A") {
          if (!value || value.trim() === '') {
            errors.numeroCuenta = 'El número de cuenta es obligatorio cuando se selecciona un banco';
          } else {
            const restriccionesCuenta = isUsEmpresa
              ? restriccionesPorBancoUs(formData.banco)
              : restriccionesPorBanco(formData.banco);
            if (restriccionesCuenta.pattern && !restriccionesCuenta.pattern.test(value)) {
              errors.numeroCuenta = restriccionesCuenta.helperText;
            } else if (restriccionesCuenta.minLength && value.length < restriccionesCuenta.minLength) {
              errors.numeroCuenta = `El número de cuenta debe tener al menos ${restriccionesCuenta.minLength} dígitos`;
            }
          }
        }
        break;
      case 'banco':
        // Si se cambia el banco, también validar el número de cuenta
        if (value && value !== "N/A") {
          if (!formData.numeroCuenta || formData.numeroCuenta.trim() === '') {
            errors.numeroCuenta = 'El número de cuenta es obligatorio cuando se selecciona un banco';
          }
        }
        break;
    }

    return errors;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Si se selecciona "N/A" en banco, automáticamente establecer numeroCuenta como "N/A"
    if (name === 'banco' && value === 'N/A') {
      setFormData({ ...formData, [name]: value, numeroCuenta: 'N/A' });
    }
    // Si se cambia de "N/A" a otro banco, limpiar el numeroCuenta
    else if (name === 'banco' && formData.banco === 'N/A' && value !== 'N/A') {
      setFormData({ ...formData, [name]: value, numeroCuenta: '' });
    }
    else {
      setFormData({ ...formData, [name]: value });
    }

    // Validación en tiempo real
    const fieldErrors = validateField(name, value);
    setRealTimeValidation(prev => ({
      ...prev,
      ...fieldErrors
    }));

    // Limpiar errores de validación si el campo ahora es válido
    if (fieldErrors[name]) {
      setValidationErrors(prev => ({
        ...prev,
        [name]: fieldErrors[name]
      }));
    } else {
      setValidationErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[name];
        return newErrors;
      });
    }
  };

  const handleClose = () => {
    setOpenDialog(false);
  };

  const handleCloseSuccessModal = () => {
    setShowSuccessModal(false);
    // Redirige a la misma página para recargar el formulario
    window.location.reload();
  };

  const handleCloseErrorModal = () => {
    setShowErrorModal(false);
  };




  useEffect(() => {
    if (isUsEmpresa) return;

    const num = formData.documento;

    // Solo consultamos cuando hay 8 dígitos completos
    if (num.length === 8) {
      const controller = new AbortController();
      // setCedulaChecking(true);

      (async () => {
        try {
          const res = await fetch(
            `https://ciuy-consumers-api.vercel.app/validate/${num}`,
            { signal: controller.signal }
          );
          const data = await res.json();
          setCedulaValid(data.valid);
        } catch (err) {
          if (err.name !== 'AbortError') setCedulaValid(false);
        } finally {
          // setCedulaChecking(false);
        }
      })();

      return () => controller.abort(); // Cancela si el usuario escribe otro dígito antes de que llegue la respuesta
    } else {
      // Aún no hay 8 dígitos; no mostramos error ni éxito
      setCedulaValid(null);
    }
  }, [formData.documento, isUsEmpresa]);


  const fetchEmpresaData = async () => {
    // Usar empresaData del contexto si está disponible, o empresaId de userData
    const empresaId = empresaData?.id || userData?.empresaId;
    if (!empresaId) {
      console.error("Error: no se encontró el ID de la empresa en el contexto.");
      return null;
    }

    // Si ya tenemos empresaData del contexto, devolverlo directamente
    if (empresaData) {
      return empresaData;
    }

    // Si no, intentar obtenerlo (aunque debería estar en el contexto)
    try {
      const response = await apiRequest(`/datos-empresa/${empresaId}`);
      if (!response.ok) {
        throw new Error('No se pudo obtener los datos de la empresa');
      }

      const empresaDataResponse = await response.json();
      return empresaDataResponse;
    } catch (error) {
      console.error('Error al obtener los datos de la empresa:', error);
      return null;
    }
  };

  const obtenerYGuardarUserId = async () => {
    try {
      const response = await apiRequest('/datos-usuario', {
        method: 'GET',
      });

      if (!response.ok) throw new Error('Error al obtener el userId');

      const data = await response.json();
      Cookies.set('userId', data.id); // Guardar el userId en las cookies
      localStorage.setItem('comision', data.comision);
    } catch (error) {
      console.error('Error al obtener y guardar userId:', error);
    }
  };

  const registrarAccion = async (accion, detalles = '') => {
    try {
      const userId = Cookies.get('userId');
      if (!userId) {
        console.error('No se pudo obtener el userId de las cookies');
        return;
      }
      const bodyData = {
        userId,
        accion,
        detalles,
        origen: 'empresas'
      };

      // Validar que origen no sea null o undefined
      if (!bodyData.origen || bodyData.origen === null) {
        console.error('ERROR: origen es null o undefined, forzando a "empresas"');
        bodyData.origen = 'empresas';
      }


      const jsonBody = JSON.stringify(bodyData);

      const response = await apiRequest('/registrar-accion', {
        method: 'POST',
        body: jsonBody
      });


      if (!response.ok) throw new Error('Error al registrar la acción');
    } catch (error) {
      console.error('Error al registrar la acción:', error);
    }
  };

  const enviarAlWebhook = async (data) => {
    try {
      // Este webhook externo no requiere autenticación de Firebase, solo Content-Type
      const response = await fetch('https://hook.us1.make.com/x9ly3lrmf6igi0f5e8ih0id3cajceddc', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          email: data.email,
          nombre: data.nombre,
          documento: data.documento,
          contraseña: data.contraseña,
          empresa: data.empresa
        })
      });

      if (!response.ok) {
        throw new Error('Error al enviar los datos al webhook');
      }

    } catch (error) {
      console.error('Error al enviar datos al webhook:', error.message);
    }

  };


  const crearUsuario = async (body, contraseñaParaWebhook) => {
    try {


      const response = await apiRequest('/pre-crear-usuario', {
        method: 'POST',
        body: JSON.stringify(body)
      });

      if (response.ok) {
        const empresaData = await fetchEmpresaData();
        const empresaNombre = empresaData ? empresaData.nombre : 'Empresa desconocida';
        setModalMessage('Usuario creado con éxito');
        setShowSuccessModal(true);
        await enviarAlWebhook({
          nombre: body.nombre,
          email: body.email,
          documento: body.documento,
          contraseña: contraseñaParaWebhook,
          empresa: empresaNombre
        });
        await registrarAccion('Crear Usuario', `Usuario ${formData.nombre} ${formData.apellido} creado`);
        await crearTarjetaTrello();
      } else {
        // Leer la respuesta del servidor para obtener el mensaje de error específico
        const errorData = await response.json();
        const errorMessage = errorData.error || 'Error desconocido al crear el usuario';
        setModalMessage(errorMessage);
        setShowErrorModal(true);
      }
    } catch (error) {
      console.error('Error al crear el usuario:', error.message);
      setModalMessage('Error al crear el usuario: ' + error.message);
      setShowErrorModal(true);
    }
  };

  const crearTarjetaTrello = async () => {
    const ahora = new Date();
    const horaFormateada = `${ahora.getHours()}:${ahora.getMinutes()}:${ahora.getSeconds()}`;
    const fechaActual = new Date();
    const dia = String(ahora.getDate()).padStart(2, '0');
    const mes = String(ahora.getMonth() + 1).padStart(2, '0');
    const anio = ahora.getFullYear();
    const fechaFormateada = `${dia}/${mes}/${anio}`;


    const empresaData = await fetchEmpresaData();
    const empresaNombre = empresaData ? empresaData.nombre : 'Empresa desconocida';
    const cardName = `${formData.nombre} ${formData.apellido} | ${empresaNombre}`;
    const cardDesc = `
    Nombre: ${formData.nombre}
    ${formData.segundoNombre ? `Segundo Nombre: ${formData.segundoNombre}` : ''}
    Apellido: ${formData.apellido}
    ${formData.segundoApellido ? `Segundo Apellido: ${formData.segundoApellido}` : ''}
    Documento de identidad: ${formData.documento}
    Banco: ${formData.banco}
    Número de Cuenta: ${formData.numeroCuenta}
    Mail: ${formData.email}
    Celular: ${formData.celular}
    Género: ${formData.genero}
    Sueldo Neto: ${formData.sueldoMensual}
    Sueldo Líquido Calculado: ${calcularSueldoLiquido()}
    Tope Retiro Máximo: ${calcularTopeRetiroMaximo()}
    Retenciones: ${formData.retenciones.map(r => `${r.tipo} - ${r.concepto} - ${r.importe}`).join(', ')}
    Fecha: ${fechaFormateada}
    Hora: ${horaFormateada}`;

    try {
      const trelloResponse = await fetch('https://api.trello.com/1/cards', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          key: "6b910cb510a7a099380c05283935a45a",
          token: "ATTA7a79f9967a5d3525f0a67f588394badb6e5812a22c6ae73ec98bebda08a624d3BB135739",
          idList: "67252ea0ff28a9a1e8313f65",
          name: cardName,
          desc: cardDesc,
        })

      });

      if (!trelloResponse.ok) {
        throw new Error('Error al crear la tarjeta en Trello');
      }
    } catch (error) {
      console.error(error);
    }

  };

  const generateUniqueId = () => {
    return Math.floor(Math.random() * 1000000000); // Genera un número entero aleatorio
  };

  const handleAction = async () => {
    setLoading(true);

    // Usar empresaData del contexto si está disponible, o empresaId de userData
    const empresaId = empresaData?.id || userData?.empresaId;
    if (!empresaId) {
      setModalMessage("Error: no se encontró el ID de la empresa en el contexto.");
      setShowErrorModal(true);
      setLoading(false);
      return;
    }

    const documentoLimpio = isUsEmpresa
      ? formData.documento.replace(/[^a-zA-Z0-9]/g, "")
      : formData.documento.replace(/\D/g, "");
    const contraseñaParaWebhook = documentoLimpio
      ? `${formData.nombre}${documentoLimpio}`
      : `${formData.nombre}${generateUniqueId()}`;

    const sueldoMensual = parseInt(formData.sueldoMensual) || 200;
    const sueldoMensualLiquido = calcularSueldoLiquido();
    const topeRetiroMaximo = calcularTopeRetiroMaximo();
    const sueldoDiario = formData.sueldoMensual ? Math.round(sueldoMensual / 30) : 0;
    const diaDelMes = new Date().getDate();
    const sueldoRestante = formData.sueldoMensual ? sueldoDiario * diaDelMes : 1000;

    // Preparar las retenciones como array de objetos limpio
    const retencionesLimpias = formData.retenciones.map(r => ({
      tipo: r.tipo,
      concepto: r.concepto,
      importe: parseInt(r.importe) || 0,
      mes: r.anio && r.mes ? `${r.anio}-${r.mes}` : '',
    }));

    const body = {
      nombre: formData.nombre,
      segundoNombre: formData.segundoNombre || '',
      apellido: formData.apellido,
      segundoApellido: formData.segundoApellido || '',
      documento: documentoLimpio,
      pais: isUsEmpresa ? "US" : (paisEmpresa || "Uruguay"),
      banco: formData.banco || "N/A",
      numeroCuenta: formData.numeroCuenta || "N/A",
      email: formData.email,
      empresaId: parseInt(empresaId),
      rol: "empleado",
      sueldoMensual: sueldoMensual,
      sueldoMensualLiquido: sueldoMensualLiquido,
      retenciones: retencionesLimpias,
      sueldoDiario: parseFloat(sueldoDiario),
      sueldoRestante: parseFloat(sueldoRestante),
      celular: parseInt(formData.celular) || 0,
      genero: formData.genero === 'femenino' ? 'F' : formData.genero === 'masculino' ? 'M' : 'No especificado',
      topeRetiroMaximo: topeRetiroMaximo,
      // TOPE RETIRO SIEMPRE DEBE SER 3000, ES DISTINTO AL TOPE RETIRO MAXIMO
      topeRetiro: 3000,
      comision: parseFloat(localStorage.getItem('comision') || 0),
      imagen: "http://url.com/imagen.jpg",
      departamento: "",
      ciudad: "",
      barrio: "",
      domicilio: "",
      moneda: isUsEmpresa ? "USD" : "UYU",
      sueldoRetirado: 0,
      activo: true,
      zafral: false,
      cuentaPruebaEducacion: false,
      totalAdelantos: 0,
      totalAdelantosMensuales: 0,
      aceptoTyC: false
    };


    await crearUsuario(body, contraseñaParaWebhook);

    setLoading(false);
    handleClose();
  };



  const handleSubmit = (e) => {
    e.preventDefault();

    // Obtener errores de validación
    const errors = getValidationErrors();
    setValidationErrors(errors);

    // Si no hay errores, abrir el diálogo de confirmación
    if (Object.keys(errors).length === 0) {
      setOpenDialog(true);
    } else {
      // Crear mensaje específico con los campos que tienen errores
      const camposConError = [];

      if (errors.nombre) camposConError.push('Nombre');
      if (errors.apellido) camposConError.push('Apellido');
      if (errors.documento) camposConError.push('Documento de identidad');
      if (errors.banco) camposConError.push('Banco');
      if (errors.numeroCuenta) camposConError.push('Número de cuenta');
      if (errors.email) camposConError.push('Email');
      if (errors.celular) camposConError.push('Celular');
      if (errors.genero) camposConError.push('Género');
      if (errors.sueldoMensual) camposConError.push('Sueldo');

      // Verificar errores en retenciones
      const retencionesConError = Object.keys(errors).filter(key => key.startsWith('retencion_'));
      if (retencionesConError.length > 0) {
        camposConError.push('Retenciones');
      }

      let mensajeError = 'Por favor, corrija los siguientes campos:\n\n';
      mensajeError += camposConError.join(', ');

      if (camposConError.length === 1) {
        mensajeError = `Por favor, corrija el campo: ${camposConError[0]}`;
      }

      setModalMessage(mensajeError);
      setShowErrorModal(true);
    }
  };

  // Se elimina la validación remota de cuenta bancaria

  // Función para validar si el formulario es válido
  const isFormValid = () => {
    const camposObligatorios = isUsEmpresa
      ? [
          formData.nombre.trim(),
          formData.apellido.trim(),
          formData.documento.trim(),
          formData.email.trim(),
          formData.genero,
        ]
      : [
          formData.nombre.trim(),
          formData.apellido.trim(),
          formData.documento,
          formData.email.trim(),
          formData.celular.trim(),
          formData.genero,
        ];

    const camposCompletos = camposObligatorios.every((campo) => campo && campo !== "");

    // Validar sueldo solo si se proporciona (es opcional)
    let sueldoValido = true;
    if (formData.sueldoMensual && formData.sueldoMensual.trim() !== '') {
      const sueldo = parseInt(formData.sueldoMensual) || 0;
      sueldoValido = sueldo > 0 && sueldo <= 300000;
    }

    const cedulaValida = isUsEmpresa
      ? true
      : cedulaValid !== false && documentoExists !== true;

    // Validar email básico
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const emailValido = emailRegex.test(formData.email);

    const celularValido = isUsEmpresa
      ? !formData.celular.trim() || formData.celular.length <= CELULAR_MAX_LENGTH_US
      : formData.celular.length === 9;

    // Las retenciones son opcionales, solo validar si existen
    let retencionesValidas = true;
    if (formData.retenciones.length > 0) {
      retencionesValidas = formData.retenciones.every(ret =>
        ret.tipo &&
        ret.concepto.trim() &&
        ret.importe &&
        parseInt(ret.importe) > 0 &&
        ret.mes &&
        ret.anio
      );
    }

    return camposCompletos &&
      sueldoValido &&
      cedulaValida &&
      emailValido &&
      celularValido &&
      retencionesValidas;
  };

  // Función para obtener mensajes de error específicos
  const getValidationErrors = () => {
    const errors = {};

    // Validar campos obligatorios
    if (!formData.nombre.trim()) {
      errors.nombre = 'El nombre es obligatorio';
    } else if (formData.nombre.trim().length < 2) {
      errors.nombre = 'El nombre debe tener al menos 2 caracteres';
    }

    if (!formData.apellido.trim()) {
      errors.apellido = 'El apellido es obligatorio';
    } else if (formData.apellido.trim().length < 2) {
      errors.apellido = 'El apellido debe tener al menos 2 caracteres';
    }

    if (isUsEmpresa) {
      if (!formData.documento.trim()) {
        errors.documento = 'El documento de identidad es obligatorio';
      }
    } else if (!formData.documento.trim()) {
      errors.documento = 'El documento de identidad es obligatorio';
    } else if (formData.documento.length !== 8) {
      errors.documento = 'El documento de identidad debe tener 8 dígitos';
    } else if (cedulaValid === false) {
      errors.documento = 'El documento de identidad no es válido según el registro civil';
    } else if (documentoExists === true) {
      errors.documento = 'Ya existe un usuario registrado con este número de documento';
    }



    if (!formData.email.trim()) {
      errors.email = 'El email es obligatorio';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      errors.email = 'El email no tiene un formato válido (ejemplo: usuario@dominio.com)';
    }

    if (!isUsEmpresa && !formData.celular.trim()) {
      errors.celular = 'El celular es obligatorio';
    } else if (formData.celular.trim() && isUsEmpresa && formData.celular.length > CELULAR_MAX_LENGTH_US) {
      errors.celular = `El número de celular no puede superar ${CELULAR_MAX_LENGTH_US} dígitos`;
    } else if (!isUsEmpresa && formData.celular.length !== 9) {
      errors.celular = 'El celular debe tener exactamente 9 dígitos';
    } else if (!isUsEmpresa && !/^09/.test(formData.celular)) {
      errors.celular = 'El celular debe comenzar con 09';
    }

    if (!formData.genero) {
      errors.genero = 'Debe seleccionar un género';
    }

    // Validar banco y número de cuenta
    if (formData.banco && formData.banco !== "N/A") {
      // Si se selecciona un banco que no es N/A, el número de cuenta es obligatorio
      if (!formData.numeroCuenta || formData.numeroCuenta.trim() === '') {
        errors.numeroCuenta = 'El número de cuenta es obligatorio cuando se selecciona un banco';
      } else {
        // Validar formato del número de cuenta según el banco
        const restriccionesCuenta = isUsEmpresa
          ? restriccionesPorBancoUs(formData.banco)
          : restriccionesPorBanco(formData.banco);
        if (restriccionesCuenta.pattern && !restriccionesCuenta.pattern.test(formData.numeroCuenta)) {
          errors.numeroCuenta = restriccionesCuenta.helperText;
        } else if (restriccionesCuenta.minLength && formData.numeroCuenta.length < restriccionesCuenta.minLength) {
          errors.numeroCuenta = `El número de cuenta debe tener al menos ${restriccionesCuenta.minLength} dígitos`;
        }
      }
    }

    if (!formData.sueldoMensual) {
    } else {
      const sueldo = parseInt(formData.sueldoMensual) || 0;
      if (sueldo <= 0) {
        errors.sueldoMensual = 'El sueldo debe ser mayor a 0';
      } else if (sueldo > 300000) {
        errors.sueldoMensual = 'El sueldo debe ser menor a 300,000. Para sueldos mayores contacte a soporte';
      } else if (!isUsEmpresa && sueldo < 10000) {
        errors.sueldoMensual = 'El sueldo debe ser mayor a 10,000';
      }
    }

    // Validar retenciones solo si se han agregado (son opcionales)
    if (formData.retenciones.length > 0) {
      formData.retenciones.forEach((ret, index) => {
        if (!ret.tipo) {
          errors[`retencion_${index}_tipo`] = 'Debe seleccionar un tipo de retención';
        }
        if (!ret.concepto.trim()) {
          errors[`retencion_${index}_concepto`] = 'El concepto es obligatorio';
        } else if (ret.concepto.trim().length < 3) {
          errors[`retencion_${index}_concepto`] = 'El concepto debe tener al menos 3 caracteres';
        }
        if (!ret.importe || parseInt(ret.importe) <= 0) {
          errors[`retencion_${index}_importe`] = 'El importe debe ser mayor a 0';
        } else if (parseInt(ret.importe) > parseInt(formData.sueldoMensual)) {
          errors[`retencion_${index}_importe`] = 'El importe no puede ser mayor al sueldo';
        }
        if (!ret.mes) {
          errors[`retencion_${index}_mes`] = 'Debe seleccionar un mes';
        }
        if (!ret.anio) {
          errors[`retencion_${index}_anio`] = 'Debe seleccionar un año';
        }
      });
    }

    return errors;
  };

  // Helpers para retenciones
  const tiposRetencion = [
    { value: 'otro', label: 'Otro' },
    { value: 'legal', label: 'Legal' },
    { value: 'financiera', label: 'Financiera (cooperativas, préstamos, tarjetas)' },
    { value: 'mutualista', label: 'Mutualista / Seguro médico' },
    { value: 'sindicato', label: 'Sindicato' },
    { value: 'embargo', label: 'Embargo judicial' },
  ];
  const meses = [
    { value: '01', label: 'Enero' },
    { value: '02', label: 'Febrero' },
    { value: '03', label: 'Marzo' },
    { value: '04', label: 'Abril' },
    { value: '05', label: 'Mayo' },
    { value: '06', label: 'Junio' },
    { value: '07', label: 'Julio' },
    { value: '08', label: 'Agosto' },
    { value: '09', label: 'Setiembre' },
    { value: '10', label: 'Octubre' },
    { value: '11', label: 'Noviembre' },
    { value: '12', label: 'Diciembre' },
  ];
  const anioActual = new Date().getFullYear();
  const anios = [anioActual, anioActual + 1, anioActual + 2];

  const handleRetencionChange = (idx, field, value) => {
    const nuevas = formData.retenciones.map((r, i) => i === idx ? { ...r, [field]: value } : r);
    setFormData({ ...formData, retenciones: nuevas });
  };
  const handleAgregarRetencion = () => {
    const nuevasRetenciones = [
      ...formData.retenciones,
      { tipo: '', concepto: '', importe: '', mes: '', anio: anioActual }
    ];
    setFormData({
      ...formData,
      retenciones: nuevasRetenciones
    });
  };
  const handleEliminarRetencion = (idx) => {
    setFormData({
      ...formData,
      retenciones: formData.retenciones.filter((_, i) => i !== idx)
    });
  };

  // Función para calcular el sueldo líquido automáticamente
  const calcularSueldoLiquido = () => {
    // Si no hay sueldo mensual, retornar 0
    if (!formData.sueldoMensual || formData.sueldoMensual.trim() === '') {
      return 0;
    }
    const sueldoMensual = parseInt(formData.sueldoMensual) || 0;
    const totalRetenciones = formData.retenciones.reduce((total, ret) => {
      return total + (parseInt(ret.importe) || 0);
    }, 0);
    return sueldoMensual - totalRetenciones;
  };

  // Función para calcular el tope de retiro máximo
  const calcularTopeRetiroMaximo = () => {
    const sueldoLiquido = calcularSueldoLiquido();
    return Math.floor(sueldoLiquido * 0.5); // 50% del sueldo líquido
  };

  const restricciones = isUsEmpresa
    ? restriccionesPorBancoUs(formData.banco)
    : restriccionesPorBanco(formData.banco);

  return (
    <DashboardLayout>
      <PageBlueHeader
        title={t('users.add.title')}
        subtitle={t('users.add.pageSubtitle')}
      />
      <ArgonBox pt={2} pb={6} sx={{ overflowX: 'hidden', boxSizing: 'border-box', maxWidth: '100vw' }}>
        <Card>
          <ArgonBox p={3}>
            <form onSubmit={handleSubmit}>
              <Grid container spacing={2}>
                {/* Primera fila */}
                <Grid item xs={12} md={4}>
                  <ArgonTypography variant="body2" sx={{ fontWeight: 'bold', mb: 1, fontSize: '0.8rem' }}>
                    {t('users.add.firstName')}
                  </ArgonTypography>
                  <TextField
                    fullWidth
                    variant="outlined"
                    name="nombre"
                    value={formData.nombre}
                    onChange={(e) => {
                      const newValue = e.target.value.replace(/[^a-zA-Z]/g, "");
                      handleChange({ target: { name: "nombre", value: newValue } });
                    }}
                    placeholder={t('users.add.firstName')}
                    error={!!validationErrors.nombre}
                    helperText={validationErrors.nombre || " "}
                    sx={{
                      '& .MuiInputBase-input': {
                        fontSize: '0.9rem',
                        py: 1.2,
                        width: '100% !important',
                      },
                      '& .MuiOutlinedInput-input': {
                        paddingLeft: '2px !important',
                      },
                      '& .MuiFormHelperText-root': {
                        fontSize: '0.75rem',
                      }
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <ArgonTypography variant="body2" sx={{ fontWeight: 'bold', mb: 1, fontSize: '0.8rem' }}>
                    {t('users.edit.secondName')}
                  </ArgonTypography>
                  <TextField
                    fullWidth
                    variant="outlined"
                    name="segundoNombre"
                    value={formData.segundoNombre}
                    onChange={(e) => {
                      const newValue = e.target.value.replace(/[^a-zA-Z]/g, "");
                      handleChange({ target: { name: "segundoNombre", value: newValue } });
                    }}
                    placeholder={t('users.edit.secondName')}
                    sx={{
                      '& .MuiInputBase-input': {
                        fontSize: '0.9rem',
                        py: 1.2,
                        width: '100% !important',
                      },
                      '& .MuiOutlinedInput-input': {
                        paddingLeft: '2px !important',
                      },
                      '& .MuiFormHelperText-root': {
                        fontSize: '0.75rem',
                      }
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <ArgonTypography variant="body2" sx={{ fontWeight: 'bold', mb: 1, fontSize: '0.8rem' }}>
                    {t('users.add.lastName')}
                  </ArgonTypography>
                  <TextField
                    fullWidth
                    placeholder={t('users.add.lastName')}
                    variant="outlined"
                    name="apellido"
                    value={formData.apellido}
                    onChange={(e) => {
                      const newValue = e.target.value.replace(/[^a-zA-Z]/g, "");
                      handleChange({ target: { name: "apellido", value: newValue } });
                    }}
                    error={!!validationErrors.apellido}
                    helperText={validationErrors.apellido || " "}
                    sx={{
                      '& .MuiInputBase-input': {
                        fontSize: '0.9rem',
                        py: 1.2,
                        width: '100% !important',
                      },
                      '& .MuiOutlinedInput-input': {
                        paddingLeft: '2px !important',
                      },
                      '& .MuiFormHelperText-root': {
                        fontSize: '0.75rem',
                      }
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <ArgonTypography variant="body2" sx={{ fontWeight: 'bold', mb: 1, fontSize: '0.8rem' }}>
                    {t('users.edit.secondLastName')}
                  </ArgonTypography>
                  <TextField
                    fullWidth
                    placeholder={t('users.edit.secondLastName')}
                    variant="outlined"
                    name="segundoApellido"
                    value={formData.segundoApellido}
                    onChange={(e) => {
                      const newValue = e.target.value.replace(/[^a-zA-Z]/g, "");
                      handleChange({ target: { name: "segundoApellido", value: newValue } });
                    }}
                    sx={{
                      '& .MuiInputBase-input': {
                        fontSize: '0.9rem',
                        py: 1.2,
                        width: '100% !important',
                      },
                      '& .MuiOutlinedInput-input': {
                        paddingLeft: '2px !important',
                      },
                      '& .MuiFormHelperText-root': {
                        fontSize: '0.75rem',
                      }
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <ArgonTypography variant="body2" sx={{ fontWeight: 'bold', mb: 1, fontSize: '0.8rem' }}>
                    {t('users.add.document')}
                  </ArgonTypography>
                  <TextField
                    fullWidth
                    variant="outlined"
                    placeholder={isUsEmpresa ? t('users.add.documentPlaceholderUs') : "XXXXXXXX"}
                    name="documento"
                    value={formData.documento}
                    error={
                      (!isUsEmpresa && (cedulaValid === false || documentoExists === true)) ||
                      !!validationErrors.documento
                    }
                    helperText={
                      !isUsEmpresa && (documentoChecking || cedulaChecking) ? "Verificando…" :
                        validationErrors.documento ||
                        (!isUsEmpresa && cedulaValid === false ? "El documento de identidad no es válido" :
                          !isUsEmpresa && documentoExists === true ? "Ya existe un usuario con este documento" : " ")
                    }
                    onChange={(e) => {
                      const clean = isUsEmpresa
                        ? e.target.value.replace(/[^a-zA-Z0-9]/g, "").slice(0, DOCUMENTO_MAX_LENGTH_US)
                        : e.target.value.replace(/\D/g, "").slice(0, 8);
                      handleChange({ target: { name: "documento", value: clean } });
                    }}
                    inputProps={
                      isUsEmpresa
                        ? { maxLength: DOCUMENTO_MAX_LENGTH_US }
                        : { inputMode: "numeric", pattern: "[0-9]*", maxLength: 8 }
                    }
                    sx={{
                      '& .MuiInputBase-input': {
                        fontSize: '0.9rem',
                        py: 1.2,
                        width: '100% !important',
                      },
                      '& .MuiOutlinedInput-input': {
                        paddingLeft: '2px !important',
                      },
                      '& .MuiFormHelperText-root': {
                        fontSize: '0.75rem',
                      }
                    }}
                  />
                </Grid>
                {/* Segunda fila */}
                <Grid item xs={12} md={4}>
                  <ArgonTypography variant="body2" sx={{ fontWeight: 'bold', mb: 1, fontSize: '0.8rem' }}>
                    Email
                  </ArgonTypography>
                  <TextField
                    fullWidth
                    placeholder="ejemplo@gmail.com"
                    variant="outlined"
                    name="email"
                    type="email"
                    value={formData.email}
                    onChange={handleChange}
                    error={!!validationErrors.email}
                    helperText={validationErrors.email || " "}
                    sx={{
                      '& .MuiInputBase-input': {
                        fontSize: '0.9rem',
                        py: 1.2,
                        width: '100% !important',
                      },
                      '& .MuiOutlinedInput-input': {
                        paddingLeft: '2px !important',
                      },
                      '& .MuiFormHelperText-root': {
                        fontSize: '0.75rem',
                      }
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <ArgonTypography variant="body2" sx={{ fontWeight: 'bold', mb: 1, fontSize: '0.8rem' }}>
                    {t(isUsEmpresa ? 'users.add.phoneOptional' : 'users.edit.phone')}
                  </ArgonTypography>
                  <TextField
                    fullWidth
                    placeholder={t('users.edit.phone')}
                    variant="outlined"
                    name="celular"
                    value={formData.celular}
                    onChange={(e) => {
                      const maxLen = isUsEmpresa ? CELULAR_MAX_LENGTH_US : 9;
                      const newValue = e.target.value.replace(/\D/g, "").slice(0, maxLen);
                      handleChange({ target: { name: "celular", value: newValue } });
                    }}
                    inputProps={{
                      inputMode: 'numeric',
                      pattern: '[0-9]*',
                      maxLength: isUsEmpresa ? CELULAR_MAX_LENGTH_US : 9
                    }}
                    error={!!validationErrors.celular}
                    helperText={validationErrors.celular || (isUsEmpresa ? t('users.add.phoneOptionalHint') : " ")}
                    sx={{
                      '& .MuiInputBase-input': {
                        fontSize: '0.9rem',
                        py: 1.2,
                        width: '100% !important',
                      },
                      '& .MuiOutlinedInput-input': {
                        paddingLeft: '2px !important',
                      },
                      '& .MuiFormHelperText-root': {
                        fontSize: '0.75rem',
                      }
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <ArgonTypography variant="body2" sx={{ fontWeight: 'bold', mb: 1, fontSize: '0.8rem' }}>
                    {t('users.edit.gender')}
                  </ArgonTypography>
                  <Select
                    fullWidth
                    variant="outlined"
                    name="genero"
                    value={formData.genero}
                    onChange={handleChange}
                    displayEmpty
                    error={!!validationErrors.genero}
                    sx={{
                      '& .MuiSelect-select': {
                        fontSize: '0.9rem',
                        py: 1.2,
                        width: '100% !important',
                        paddingLeft: '2px !important',
                      },
                      '& .MuiFormHelperText-root': {
                        fontSize: '0.75rem',
                      }
                    }}
                  >
                    <MenuItem value="" disabled>
                      {t('common.select')}
                    </MenuItem>
                    <MenuItem value="masculino">{t('users.gender.male')}</MenuItem>
                    <MenuItem value="femenino">{t('users.gender.female')}</MenuItem>
                    <MenuItem value="otro">{t('users.gender.other')}</MenuItem>
                  </Select>
                  {validationErrors.genero && (
                    <ArgonTypography variant="caption" color="error" sx={{ mt: 0.5, display: 'block' }}>
                      {validationErrors.genero}
                    </ArgonTypography>
                  )}
                </Grid>
                {/* Tercera fila */}
                <Grid item xs={12} md={4}>
                  <ArgonTypography variant="body2" sx={{ fontWeight: 'bold', mb: 1, fontSize: '0.8rem' }}>
                    {t('users.add.bank')}
                  </ArgonTypography>
                  <Select
                    fullWidth
                    variant="outlined"
                    name="banco"
                    value={formData.banco}
                    onChange={handleChange}
                    displayEmpty
                    error={!!validationErrors.banco}
                    sx={{
                      '& .MuiSelect-select': {
                        fontSize: '0.9rem',
                        py: 1.2,
                        width: '100% !important',
                        paddingLeft: '2px !important',
                      },
                      '& .MuiFormHelperText-root': {
                        fontSize: '0.75rem',
                      }
                    }}
                  >
                    <MenuItem value="" disabled>
                      {t('common.select')}
                    </MenuItem>
                    {bancosDisponibles.map((banco) => (
                      <MenuItem key={banco.value} value={banco.value}>
                        {banco.label}
                      </MenuItem>
                    ))}
                  </Select>
                  {validationErrors.banco && (
                    <ArgonTypography variant="caption" color="error" sx={{ mt: 0.5, display: 'block' }}>
                      {validationErrors.banco}
                    </ArgonTypography>
                  )}
                </Grid>
                <Grid item xs={12} md={4}>
                  <ArgonTypography variant="body2" sx={{ fontWeight: 'bold', mb: 1, fontSize: '0.8rem' }}>
                    {t('users.add.accountNumber')}
                  </ArgonTypography>
                  <TextField
                    fullWidth
                    placeholder={formData.banco === "N/A" ? "N/A" : t('users.add.accountNumber')}
                    variant="outlined"
                    name="numeroCuenta"
                    value={formData.banco === "N/A" ? "N/A" : formData.numeroCuenta}
                    onChange={(e) => {
                      if (formData.banco === "N/A") return; // No permitir cambios si banco es N/A
                      let newValue = e.target.value.replace(/\D/g, "");
                      if (restricciones.maxLength) newValue = newValue.slice(0, restricciones.maxLength);
                      handleChange({ target: { name: "numeroCuenta", value: newValue } });
                    }}
                    disabled={formData.banco === "N/A"}
                    inputProps={{
                      inputMode: 'numeric',
                      pattern: restricciones.pattern?.source,
                      maxLength: restricciones.maxLength,
                      minLength: restricciones.minLength
                    }}
                    error={!!validationErrors.numeroCuenta}
                    helperText={validationErrors.numeroCuenta || restricciones.helperText}
                    sx={{
                      '& .MuiInputBase-input': {
                        fontSize: '0.9rem',
                        py: 1.2,
                        width: '100% !important',
                      },
                      '& .MuiOutlinedInput-input': {
                        paddingLeft: '2px !important',
                      },
                      '& .MuiFormHelperText-root': {
                        fontSize: '0.75rem',
                      },
                      '& .MuiInputBase-root.Mui-disabled': {
                        backgroundColor: '#f5f5f5',
                        '& .MuiInputBase-input': {
                          WebkitTextFillColor: '#666666',
                          color: '#666666',
                        },
                        '& .MuiOutlinedInput-notchedOutline': {
                          borderColor: '#e0e0e0',
                        }
                      }
                    }}
                  />

                </Grid>
                <Grid item xs={12} md={4}>
                  <ArgonTypography variant="body2" sx={{ fontWeight: 'bold', mb: 1, fontSize: '0.8rem' }}>
                    {t('users.add.netSalary')}
                  </ArgonTypography>
                  <TextField
                    fullWidth
                    placeholder={t(isUsEmpresa ? 'users.add.netSalaryExampleUs' : 'users.add.netSalaryExample')}
                    variant="outlined"
                    name="sueldoMensual"
                    value={formData.sueldoMensual}
                    onChange={(e) => {
                      let newValue = e.target.value.replace(/\D/g, "").slice(0, 6); // Solo números, máximo 6 caracteres
                      // Asegurar que el valor sea mayor a 0 y menor a 300000
                      if (newValue === "0") newValue = "";

                      handleChange({ target: { name: "sueldoMensual", value: newValue } });
                    }}
                    inputProps={{
                      inputMode: 'numeric',
                      pattern: '[0-9]*',
                      maxLength: 6,
                      min: 1,
                      max: 300000
                    }}
                    error={formData.sueldoMensual === "0" || (formData.sueldoMensual && parseInt(formData.sueldoMensual) > 300000) || !!validationErrors.sueldoMensual}
                    helperText={
                      validationErrors.sueldoMensual ||
                      (formData.sueldoMensual === "0"
                        ? "El sueldo debe ser mayor a 0"
                        : (formData.sueldoMensual && parseInt(formData.sueldoMensual) > 300000)
                          ? "El sueldo debe ser menor a 300000, por aclaraciones consultar a Soporte"
                          : "")
                    }
                    sx={{
                      '& .MuiInputBase-input': {
                        fontSize: '0.9rem',
                        py: 1.2,
                        width: '100% !important',
                      },
                      '& .MuiOutlinedInput-input': {
                        paddingLeft: '2px !important',
                      },
                      '& .MuiFormHelperText-root': {
                        fontSize: '0.75rem',
                      }
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <ArgonTypography variant="body1" sx={{ mt: 2, mb: 1, color: '#000000', fontWeight: '600', fontSize: '1.1rem' }}>
                    {t('users.add.withholdings')}
                  </ArgonTypography>
                  {formData.retenciones.map((ret, idx) => (
                    <Grid container spacing={1} key={idx} alignItems="flex-start" sx={{ mb: 1 }}>
                      <Grid item xs={12} md={2}>
                        <ArgonTypography variant="body2" sx={{ fontWeight: 'bold', mb: 1, fontSize: '0.8rem' }}>
                          {t('users.edit.type')}
                        </ArgonTypography>
                        <Select
                          fullWidth
                          value={ret.tipo}
                          onChange={e => handleRetencionChange(idx, 'tipo', e.target.value)}
                          displayEmpty
                          error={!!validationErrors[`retencion_${idx}_tipo`]}
                          sx={{
                            '& .MuiSelect-select': {
                              fontSize: '0.9rem',
                              py: 1.2,
                              paddingLeft: '2px !important',
                            },
                          }}
                        >
                          <MenuItem value="" disabled>{t('users.edit.type')} ▼</MenuItem>
                          {tiposRetencion.map(opt => (
                            <MenuItem key={opt.value} value={opt.value}>{opt.label}</MenuItem>
                          ))}
                        </Select>
                        {validationErrors[`retencion_${idx}_tipo`] && (
                          <ArgonTypography variant="caption" color="error" sx={{ mt: 0.5, display: 'block' }}>
                            {validationErrors[`retencion_${idx}_tipo`]}
                          </ArgonTypography>
                        )}
                      </Grid>
                      <Grid item xs={12} md={3}>
                        <ArgonTypography variant="body2" sx={{ fontWeight: 'bold', mb: 1, fontSize: '0.8rem' }}>
                          {t('users.edit.concept')}
                        </ArgonTypography>
                        <TextField
                          fullWidth
                          placeholder={t('users.edit.concept')}
                          value={ret.concepto}
                          onChange={e => handleRetencionChange(idx, 'concepto', e.target.value)}
                          error={!!validationErrors[`retencion_${idx}_concepto`]}
                          helperText={validationErrors[`retencion_${idx}_concepto`] || " "}
                          sx={{
                            '& .MuiOutlinedInput-input': {
                              paddingLeft: '2px !important',
                            },
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} md={2}>
                        <ArgonTypography variant="body2" sx={{ fontWeight: 'bold', mb: 1, fontSize: '0.8rem' }}>
                          {t('users.edit.amount')}
                        </ArgonTypography>
                        <TextField
                          fullWidth
                          placeholder={t('users.edit.amount')}
                          type="number"
                          value={ret.importe}
                          onChange={e => handleRetencionChange(idx, 'importe', e.target.value.replace(/\D/g, ''))}
                          inputProps={{ min: 0 }}
                          error={!!validationErrors[`retencion_${idx}_importe`]}
                          helperText={validationErrors[`retencion_${idx}_importe`] || " "}
                          sx={{
                            '& .MuiOutlinedInput-input': {
                              paddingLeft: '2px !important',
                            },
                          }}
                        />
                      </Grid>
                      <Grid item xs={6} md={2}>
                        <ArgonTypography variant="body2" sx={{ fontWeight: 'bold', mb: 1, fontSize: '0.8rem' }}>
                          {t('users.edit.month')}
                        </ArgonTypography>
                        <Select
                          fullWidth
                          value={ret.mes}
                          onChange={e => handleRetencionChange(idx, 'mes', e.target.value)}
                          displayEmpty
                          error={!!validationErrors[`retencion_${idx}_mes`]}
                          sx={{
                            '& .MuiSelect-select': {
                              paddingLeft: '2px !important',
                            },
                          }}
                        >
                          <MenuItem value="" disabled>{t('users.edit.month')} ▼</MenuItem>
                          {meses.map(opt => (
                            <MenuItem key={opt.value} value={opt.value}>{opt.label}</MenuItem>
                          ))}
                        </Select>
                        {validationErrors[`retencion_${idx}_mes`] && (
                          <ArgonTypography variant="caption" color="error" sx={{ mt: 0.5, display: 'block' }}>
                            {validationErrors[`retencion_${idx}_mes`]}
                          </ArgonTypography>
                        )}
                      </Grid>
                      <Grid item xs={6} md={2}>
                        <ArgonTypography variant="body2" sx={{ fontWeight: 'bold', mb: 1, fontSize: '0.8rem' }}>
                          {t('users.edit.year')}
                        </ArgonTypography>
                        <Select
                          fullWidth
                          value={ret.anio}
                          onChange={e => handleRetencionChange(idx, 'anio', e.target.value)}
                          error={!!validationErrors[`retencion_${idx}_anio`]}
                          sx={{
                            '& .MuiSelect-select': {
                              paddingLeft: '2px !important',
                            },
                          }}
                        >
                          {anios.map(opt => (
                            <MenuItem key={opt} value={opt}>{opt}</MenuItem>
                          ))}
                        </Select>
                        {validationErrors[`retencion_${idx}_anio`] && (
                          <ArgonTypography variant="caption" color="error" sx={{ mt: 0.5, display: 'block' }}>
                            {validationErrors[`retencion_${idx}_anio`]}
                          </ArgonTypography>
                        )}
                      </Grid>
                      <Grid item xs={12} md={1}>
                        <ArgonBox display="flex" alignItems="center" justifyContent="center" sx={{ height: '56px', mt: 2.5 }}>
                          <Button
                            color="error"
                            onClick={() => handleEliminarRetencion(idx)}
                            startIcon={<DeleteIcon />}
                            sx={{
                              color: '#f5365c',
                              '&:hover': {
                                color: '#c72a49',
                              }
                            }}
                          />
                        </ArgonBox>
                      </Grid>
                    </Grid>
                  ))}
                  <Button
                    color="primary"
                    size="small"
                    endIcon={<AddIcon />}
                    onClick={handleAgregarRetencion}
                    sx={{
                      mt: 2,
                      mb: 2,
                      fontWeight: 'bold',
                      fontSize: '0.875rem',
                      backgroundColor: 'rgba(30, 134, 246, 0.11)',
                      color: '#1E86F6',
                      borderRadius: 1, // Menos border radius (antes probablemente era 2)
                      '&:hover': {
                        backgroundColor: 'rgba(26, 115, 210, 0.2)',
                        color: '#1E86F6',
                      },
                    }}
                  >
                    {t('users.add.addWithholding')}
                  </Button>
                </Grid>
                <Grid item xs={12}>
                  <ArgonBox
                    sx={{
                      p: 1.5,

                      borderRadius: 1,
                      backgroundColor: '#F8F8F8',
                      textAlign: 'right',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'flex-end'
                    }}
                  >
                    <ArgonTypography variant="body2" color="#666666" sx={{ fontSize: '0.95rem', mb: 0.2 }}>
                      {t('users.edit.liquidSalary')}
                    </ArgonTypography>
                    <ArgonTypography variant="h6" color="#000000" fontWeight="bold" sx={{ fontWeight: 'bold', fontSize: '1.2rem' }}>
                      ${calcularSueldoLiquido().toLocaleString()}
                    </ArgonTypography>
                  </ArgonBox>
                </Grid>
                <Grid item xs={12}>
                  <ArgonBox display="flex" justifyContent="flex-end">
                    <Button
                      variant="contained"
                      type="submit"
                      disabled={!isFormValid()}
                      sx={{
                        px: 4,
                        py: 1.5,
                        fontSize: '1rem',
                        fontWeight: 'normal',
                        backgroundColor: '#f8f8f8',
                        color: '#333333',
                        border: '1px solid #d1d3d4',
                        borderRadius: 2,
                        textTransform: 'none',
                        boxShadow: 'none',
                        '&:hover': {
                          backgroundColor: '#f0f0f0',
                          boxShadow: 'none',
                        },
                        '&:disabled': {
                          backgroundColor: 'rgba(80, 80, 80, 0.04)',
                          color: '#3B3B3B',
                          border: 'none',
                          boxShadow: 'none',
                        },
                        ...(isFormValid() && {
                          backgroundColor: '#1E86F6',
                          color: 'white',
                          fontWeight: 'bold',
                          border: 'none',
                          '&:hover': {
                            backgroundColor: '#0d6efd',
                            boxShadow: 'none',
                          },
                        })
                      }}
                    >
                      {t('users.add.createBtn')}
                    </Button>
                  </ArgonBox>
                </Grid>
              </Grid>
            </form>
          </ArgonBox>
        </Card>
      </ArgonBox>
      <Footer />


      <Dialog
        open={openDialog}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          sx: {
            borderRadius: '12px',
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.15)',
            padding: 0
          }
        }}
      >
        <DialogTitle id="alert-dialog-title" sx={{
          fontSize: '1.25rem',
          fontWeight: 'bold',
          padding: '24px 24px 8px 24px',
          textAlign: 'left'
        }}>
          {t('users.add.confirm.title')}
        </DialogTitle>
        <DialogContent sx={{ padding: '8px 24px 16px 24px' }}>
          <DialogContentText id="alert-dialog-description" sx={{
            color: '#666',
            fontSize: '1rem',
            lineHeight: '1.5'
          }}>
            {t('users.add.confirm.text')}
          </DialogContentText>
          {loading && (
            <ArgonBox display="flex" justifyContent="center" alignItems="center" mt={2}>
              <CircularProgress />
            </ArgonBox>
          )}
        </DialogContent>
        <div style={{
          padding: '16px 24px 24px 24px',
          display: 'flex',
          justifyContent: 'flex-end',
          gap: '12px'
        }}>
          <button
            onClick={handleAction}
            autoFocus
            disabled={loading}
            style={{
              backgroundColor: loading ? '#ccc' : '#1E86F6',
              color: loading ? '#666' : 'white',
              fontSize: '1rem',
              fontWeight: '500',
              padding: '8px 16px',
              borderRadius: '8px',
              border: 'none',
              cursor: loading ? 'not-allowed' : 'pointer',
              outline: 'none',
              opacity: loading ? 0.7 : 1
            }}
            onMouseEnter={(e) => !loading && (e.target.style.backgroundColor = '#176eca')}
            onMouseLeave={(e) => !loading && (e.target.style.backgroundColor = '#1E86F6')}
          >
            {t('common.confirm')}
          </button>
          <button
            onClick={handleClose}
            style={{
              backgroundColor: 'transparent',
              color: '#1E86F6',
              fontSize: '1rem',
              fontWeight: '500',
              padding: '8px 16px',
              border: 'none',
              cursor: 'pointer',
              outline: 'none'
            }}
          >
            {t('common.cancel')}
          </button>
        </div>
      </Dialog>

      {/* Modal de éxito */}
      <Dialog
        open={showSuccessModal}
        onClose={handleCloseSuccessModal}
        aria-labelledby="success-dialog-title"
        aria-describedby="success-dialog-description"
      >
        <DialogTitle id="success-dialog-title" sx={{ color: '#4caf50' }}>
          <ArgonBox display="flex" alignItems="center" gap={1}>
            <CheckCircleIcon sx={{ color: '#4caf50' }} />
            {t('users.add.success.title')}
          </ArgonBox>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="success-dialog-description">
            {modalMessage}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseSuccessModal} color="primary" variant="contained">
            {t('users.add.continue')}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Modal de error */}
      <Dialog
        open={showErrorModal}
        onClose={handleCloseErrorModal}
        aria-labelledby="error-dialog-title"
        aria-describedby="error-dialog-description"
      >
        <DialogTitle id="error-dialog-title" sx={{ color: '#f44336' }}>
          <ArgonBox display="flex" alignItems="center" gap={1}>
            <ErrorIcon sx={{ color: '#f44336' }} />
            Error
          </ArgonBox>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="error-dialog-description">
            {modalMessage}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseErrorModal} color="primary">
            {t('common.close')}
          </Button>
        </DialogActions>
      </Dialog>
    </DashboardLayout>
  );
}

export default AgregarUsuario;
